module.exports = __webpack_public_path__ + "static/media/Pullman Avenue, Half Moon Bay, CA10.efae7169.jpg";